import { render, staticRenderFns } from "./OnePager.vue?vue&type=template&id=484a7ed6&scoped=true&lang=pug&"
import script from "./OnePager.vue?vue&type=script&lang=js&"
export * from "./OnePager.vue?vue&type=script&lang=js&"
import style0 from "./OnePager.vue?vue&type=style&index=0&id=484a7ed6&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "484a7ed6",
  null
  
)

export default component.exports